import React, { useEffect, useRef } from "react";
import MaterialTable, { MTableAction } from "material-table";
import {
    Box,
    CircularProgress,
} from "@mui/material";
import { useSelector } from "react-redux";
import { useState } from "react";
import { useDispatch } from "react-redux";
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { GetEmployeesAction } from "../../../../../store/Employee/Employee/Action";
import EmployeePayroleTemplate from "./EmployeePayroleTemplate";
import { ConvertDateTime } from "../../../Base/helper/baseFunctions";
import Popup from "../../../Base/views/Popup";
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import { getExportEmployeeDataHelper } from "../../helper/ProfileHelper";
import CustomToggle from "../../../Base/views/CustomToggle";
import { GetFoodAllowanceAction, GetLeaveWageAction, GetPayrollTemplateAction, GetPHAllowanceAction, GetTransportAllowanceAction } from "../../../../../store/Finance/PayRollTemplate/Action";
import SelectableMultiSelect from "../../../Base/views/SelectableMultiSelect";
import { GetUserWorkLocationHelper } from "../../../Employee/helper/EmployeeHelper";
// Payroll > Employee Payroll
const MyEmployeePayrole = () => {
    const dispatch = useDispatch();
    const [openTemplate, setOpenTemplate] = useState(false);
    const [currentData, setCurrentData] = useState("")
    const [selectedRows, setSelectedRows] = useState([]);
    const [isExporting, setIsExporting] = useState(false);
    const [inactive, setInactive] = useState(false);
    const [filters, setFilters] = useState({
        ats_work_location_id: []
    });
    const pageRef = useRef(0);
    const { isEmployeeLoading, employees_options_data } = useSelector(
        (state) => state?.EmployeeReducer.EmployeesReducer
    );
    const handleToggle = (e) => {
        setInactive(!inactive);
    };
    useEffect(() => {
        dispatch(GetPayrollTemplateAction())
        dispatch(GetLeaveWageAction());
        dispatch(GetTransportAllowanceAction());          
        dispatch(GetPHAllowanceAction());
        dispatch(GetFoodAllowanceAction());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(() => {
        const locationPayload = JSON.stringify((filters?.ats_work_location_id || [])?.map((item) => ({ ats_work_location_id: item?.work_location_id })));
        dispatch(GetEmployeesAction({ is_active: true,
            ats_work_location_json: (filters?.ats_work_location_id || [])?.length > 0 ? locationPayload : null 
         }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[filters])
    const hanldeEdit = (data) => {
        setOpenTemplate(true);
        setCurrentData(data);
    };

    const getSelectedEmployeeIds = async () => {
        try {
            const selectedEmployeeIds = `{${selectedRows?.map((item) => item.employee_id).join(",")}}`;
            const res = await getExportEmployeeDataHelper({ employees_id: selectedEmployeeIds !== '{}' ? selectedEmployeeIds : null });

            if (res?.data?.statuscode === 200) {
                return res?.data?.data;
            }
        } finally {
            setIsExporting(false);
        }
    }

    const handleExportSelected = async () => {
        setIsExporting(true);
        const selectedEmp = await getSelectedEmployeeIds();
        const headers = [
            { label: "#", key: "serial_number" },
            { label: "Emp No", key: "emp_no" },
            { label: "First Name", key: "first_name" },
            { label: "Last Name", key: "last_name" },
            { label: "Designation", key: "designation" },
            { label: "Department", key: "department" },
            { label: "Reporting Manager", key: "reporting_manager" },
            { label: "Work Location", key: "work_location" },
            { label: "Date of Joining", key: "doj" },
            { label: "UAN Number", key: "uan" },
            { label: "Overtime Eligibility", key: "overtime_eligibility" },
            { label: "Basic", key: "basic" },
            { label: "Dearness Allowance", key: "Dearness_Allowance" },
            { label: "Variable Dearness Allowance", key: "Variable_Dearness_Allowance" },
            { label: "HRA", key: "hra" },
            { label: "Other Allowances", key: "other_allowances" },
            { label: "Monthly Gross Salary", key: "Monthly_Gross_Salary" },
            { label: "EPF Employer Contribution", key: "EPF_Employer_Contribution" },
            { label: "ESI Employer Contribution", key: "ESI_Employer_Contribution" },
            { label: "LTA", key: "Annual_LTA" },
            { label: "Medical Allowance", key: "Annual_Medical_Allowance" },
            { label: "Variable Pay", key: "Annual_Variable_Pay" },
            { label: "Annual CTC", key: "Annual_CTC" },
            { label: "Gratuity", key: "gratuity" }
        ];

        const csvData = [headers.map(header => header.label)];

        selectedEmp?.forEach((row, index) => {
            const rowData = headers.map(header => {
                if (header.key === "serial_number") return index + 1;
                return row?.employee_payroll_report?.[0]?.[header.key] ?? "";
            });
            csvData.push(rowData);
        });

        const csv = csvData.map(row => row.join(",")).join("\n");
        const blob = new Blob([csv], { type: "text/csv" });
        const url = URL.createObjectURL(blob);
        const downloadLink = document.createElement("a");
        downloadLink.href = url;
        downloadLink.download = "Employees Salary Master Report.csv";
        downloadLink.setAttribute("target", "_blank");
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
        URL.revokeObjectURL(url);
        setIsExporting(false);
    };

    
    const [worklocationData, setWorklocationData] = useState({
          load: true,
          values: [],
        });
        const handleWorkLoacation = () => {
          GetUserWorkLocationHelper().then(res => {
            if(res?.data?.statuscode === 200){
              setWorklocationData({ load: false, values: res?.data?.data || [] })
            } else {
              setWorklocationData({ load: false, values: [] })
            }
          })
        }
    const handleFilterChange = (event, value) => {
        if (["ats_work_location_id"].includes(event)) {
        if (value) {
            setFilters({ ...filters, [event]: value });
        } else {
            setFilters({ ...filters, [event]: "" });
        }
      }
    }
    return (
        <>
            <Box sx={{ maxHeight: "calc(100vh - 115px)", overflowY: "auto"}}>         
                <MaterialTable
                    onRowClick={(event, rowData) => hanldeEdit(rowData)}
                    isLoading={isEmployeeLoading}
                    columns={[
                        {
                            title: "Name",
                            cellStyle: { padding: "10px 10px 10px 13px" },
                            field: "name",
                            grouping: false,
                        },
                        {
                            title: "Email",
                            cellStyle: { padding: "10px 10px 10px 13px" },
                            field: "office_email",
                            grouping: false,
                        },
                        {
                            title: "Work Location",
                            cellStyle: { padding: "10px 10px 10px 13px"},
                            field: "work_location",
                            grouping: false,
                            render: (rowData) => {
                                return rowData?.work_location || "N/A";
                            }
                        },
                        {
                            title: "Joining Date",
                            cellStyle: { padding: "10px 10px 10px 13px" },
                            field: "doj",
                            render: (rowData) => {
                                return ConvertDateTime(rowData.doj);
                            },
                        },
                        {
                            title: "Payroll Setup", field: "payroll_setup_flag", headerStyle: { textAlign: "left" }, cellStyle: { padding: "10px 10px 10px 35px", textAlign: "left" },
                            render: rowData => {
                                return rowData.payroll_setup_flag ? <TaskAltIcon sx={{ color: "rgb(86, 202, 0)" }} />
                                    : <HighlightOffIcon sx={{ color: "rgb(255, 76, 81)" }} />
                            }
                        },
                    ]}
                    data={employees_options_data?.filter((emp) => {
                        if (inactive) {
                            return emp?.payroll_onhold === true;
                        } else {
                            return !emp?.payroll_onhold;
                        }
                    })}
                    options={{
                        maxBodyHeight: "calc(100vh - 250px)",
                        minBodyHeight: "calc(100vh - 250px)",
                        rowStyle: { fontSize: "13px" },
                        headerStyle: { padding: "10px 10px 10px 13px", fontWeight: "bold" },
                        sorting: true,
                        search: true,
                        searchText: "",
                        searchFieldAlignment: "left",
                        searchAutoFocus: true,
                        searchFieldVariant: "standard",
                        filtering: false,
                        page: pageRef?.current,
                        paging: true,
                        pageSizeOptions: [25, 50],
                        pageSize: 25,
                        paginationType: "stepped",
                        showFirstLastPageButtons: false,
                        paginationPosition: "bottom",
                        exportButton: false,
                        exportAllData: false,
                        exportFileName: "Employees",
                        addRowPosition: "first",
                        selection: true,
                        actionsColumnIndex: -1,
                        showSelectAllCheckbox: true,
                        showTextRowsSelected: true,
                        grouping: false,
                        columnsButton: false,
                    }}
                    onChangePage={(page) => (pageRef.current = page)}
                    onSelectionChange={(rows) => setSelectedRows(rows)}
                    actions={[
                        {
                            icon: () => (
                                <Box id="filters" sx={{display: "flex", alignItems: "center", gap: 2}}>
                                    <Box sx={{width: "210px", display: "flex", alignItems: "center", pt: 0.5}}>
                                        <SelectableMultiSelect
                                            multiple
                                            label="Work Location"
                                            placeholder="Select Location"
                                            value={filters?.ats_work_location_id}
                                            loading={handleWorkLoacation}
                                            fieldLabel="work_location_name"
                                            name="ats_work_location_id"
                                            size="small"
                                            onChangeEvent={handleFilterChange}
                                            data={worklocationData}
                                            menuHeight={150} // optional
                                        />
                                    </Box>
                                    <CustomToggle
                                        isChecked={inactive}
                                        setIsChecked={handleToggle}
                                        handleToggleChange={handleToggle}
                                        Yestext={"Onhold"}
                                        NoText={"Active"}
                                        style={{
                                            height: "35px",
                                            padding: "0px",
                                            labelPadding: "2px 5px",
                                        }}
                                    />
                                </Box>
                            ),
                            position: "row",
                            isFreeAction: true,
                        },
                        {
                            icon: () => (isExporting ? <CircularProgress size={24} /> : <CloudDownloadIcon />),
                            tooltip: 'Export',
                            onClick: () => handleExportSelected(),
                            disabled: isExporting,
                            hidden: selectedRows.length === 0,
                        },
                    ]}
                    components={{
                        Action: (props) => {
                            const ActionComponent = props?.components?.Action || MTableAction;
                            if (props?.action?.icon && typeof props?.action?.icon === "function") {
                            const IconElement = props?.action?.icon();
                            // Check if the rendered element is CustomToggle
                            if (IconElement?.props?.id === "filters") {
                                return (
                                <Box
                                    sx={{
                                        "& .MuiIconButton-root": {
                                            background: "transparent !important",
                                            boxShadow: "none !important",
                                            padding: "0px !important",
                                            margin: "0px !important",
                                            borderRadius: "0px !important",
                                            "&:hover": {
                                            background: "transparent !important",
                                            },
                                        },
                                        "& .MuiTouchRipple-root": {
                                            display: "none",
                                        },
                                    }}
                                >
                                    <ActionComponent {...props} />
                                </Box>
                                );
                            }
                            }
                            return <ActionComponent {...props} />;
                        },
                    }}
                    title=""
                />
                <Popup
                    maxWidth="sm"
                    fullWidth={true}
                    title={`Payroll Configuration - ${currentData?.name}`}
                    openPopup={openTemplate}
                    setOpenPopup={setOpenTemplate}
                >
                    <EmployeePayroleTemplate 
                        emp={true} 
                        createEmp={false} 
                        setOpenTemplate={setOpenTemplate} 
                        openTemplate={openTemplate} 
                        currentData={currentData} 
                        callAllowanceAction={false}
                    />
                </Popup>
            </Box>
        </>
    );
};

export default MyEmployeePayrole;